import { render, staticRenderFns } from "./TableHierarchicalDocPackage.vue?vue&type=template&id=7892a146&"
import script from "./TableHierarchicalDocPackage.vue?vue&type=script&lang=js&"
export * from "./TableHierarchicalDocPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports